/**
 * ICON转换库 国际化
 */
export default {
  carrierType: {
    incubator: '保温箱',
    refrigerator: '冰箱',
    vehicle: '车辆',
    refrigeratory: '冷库'
  },
  abnormal: {
    sensorConnect: '传感器连接异常',
    sensorTemp: '传感器温度异常',
    sensorHum: '传感器湿度异常',
    gatewayConnect: '网关连接异常',
    gatewayBlackout: '网关断电异常',
    displayConnect: '显示屏连接异常',
    relayConnect: '中继连接异常',
    relayRetain: '保留异常'
  },
  carrierStatus: {
    running: '运行',
    obsolete: '报废',
    spare: '备用',
    require: '待修',
    defrost: '除霜'
  },
  equiStatus: {
    offline: '离线',
    running: '在线',
    stop: '停用'
  },
  isAbnormal: {
    normal: '正常',
    abnormal: '设备异常'
  },
  isCarrierAbnormal: {
    normal: '正常',
    abnormal: '异常',
    stop: '停止'
  },
  sensorType: {
    ZigBeeTemp: 'ZigBee温度计',
    ZigBeeTempHum: 'ZigBee温湿度计',
    LoraTemp: 'Lora温度计',
    LoraTempHum: 'Lora温湿度计',
    ZetaTemp: 'Zeta温度计',
    ZetaTempHum: 'Zeta温湿度计',
    ZigBee2Temp: '二代Zigbee温度计',
    ZigBee2TempHum: '二代Zigbee温湿度计',
    FourGTemp: '4G温度计',
    FourGTempHum: '4G温湿度计',
    FourGTempGps: '4G温度计带Gps',
    FourGTempHumGps: '4G温湿度计带Gps'
  },
  configStatus: {
    wait: '等待配置',
    configuring: '配置中',
    configured: '已配置',
    fail: '配置失败'
  },
  gatewayType: {
    gw1: '网关1.0',
    gw1GPS: '网关1.0带Gps',
    gw2: '网关2.0',
  },
  displayType: {
    dsp1: '显示屏1.0'
  },
  relayType: {
    relay1: '中继1.0'
  },
  equiType: {
    sensor: '传感器',
    gateway: '网关',
    display: '显示屏',
    relay: '中继',
    gas: '气体',
    magnetism: '门磁',
    air: '空气',
    base: '智能底座',
  },
  gasType: {
    '0x00': '烟雾/丙烷',
    '0x01': '甲烷气体',
    '0x04': '一氧化碳',
    '0x0A': '丙烷气体',
    '0x32': '甲烷/丙烷/异丁烷',
    'gs_6': '二氧化碳'
  },
  magnetismType: {
    m1: '门磁1.0'
  },
  baseType: {
    bt_915: '915系列底座',
    bt_433: '433系列底座',
    bt_g: '2.4G系列底座',
    bt_4g: '4G系列底座',
    pt_1: '温度计底座',
    pt_2: '温湿度计底座',
  },
  // 设备是否可跟踪
  traceOn: '是',
  traceOff: '否',
  // 分析项图标
  analEx: '异常',
  analAlarm: '报警',
  analNormalAbnormal: '正常/异常',
  analOffline: '离线',
  analConfigure: '配置',
  analPowerout: '断电',
  // 下载状态
  generating: '生成中',
  generated: '已生成',
  genFail: '生成失败'

}
